import { z } from 'zod'

export const PaymentService = z.enum(['applePay', 'googlePay'])
